// Copyright (c) StrangeBee 2023

import { DisplayTags } from '@Atoms/Display';
import { classList } from '@Helpers/';
import React, { ReactElement, ReactNode } from 'react';

import './InfoDetail.scss';

type InfoDetailProps = {
    name?: ((...args: any[]) => ReactNode) | ReactNode;
    value: any;
    render?: (...args: any[]) => any;
    className?: string;
    data?: any;
};

const EmptyValue = () => <span>None</span>;

const SubInfoList: Record<string, (...args: any[]) => any> = {
    array: (value: string[]): ReactElement => (value.length ? <DisplayTags tags={value} /> : <EmptyValue />),
    boolean: (value: any): ReactElement => (value ? <span>TRUE</span> : <span>FALSE</span>),
    default: (value: string): ReactElement => (value ? <span>{value}</span> : <EmptyValue />),
};

const getType = (value: any): string => {
    const result = typeof value;

    if (result === 'object') {
        if (Array.isArray(value)) {
            return 'array';
        }
    }

    return result;
};

const InfoDetail = ({ name, value, render, className, data }: InfoDetailProps): ReactElement => {
    const valueType = getType(value);

    return (
        <div className={classList('info__wrapper', className, { 'has-name': !!name })}>
            {name && <div className="info__title">{typeof name === 'function' ? name(value) : name}</div>}
            <div className="info__value">{(render || SubInfoList[valueType] || SubInfoList.default)(value, data)}</div>
        </div>
    );
};

export default InfoDetail;
